import { reportContentConstants } from '../../_constants';
import { reportContentService } from '../../_services';

export const getReportContentAction = {
    reportContentHandler,
    getOrientationListHandler,
    getSlotListHandler,
};

function reportContentHandler(data, type) {
    return dispatch => {
        dispatch(request(data));
        reportContentService.reportContentHandler(data, type)
            .then(
                reportContent => {
                    dispatch(success(reportContent));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(data) { return { type: reportContentConstants.REQUEST_REPORT_CONTENT, data } }
    function success(reportContent) { return { type: reportContentConstants.RECEIVE_REPORT_CONTENT, reportContent } }
    function failure(error) { return { type: reportContentConstants.REPORT_CONTENT_ERROR, error } }
}



function getOrientationListHandler() {
    return dispatch => {
        dispatch(request());
        reportContentService.getOrientationListHandler()
            .then(
                orientationList => {
                    dispatch(success(orientationList));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: reportContentConstants.REQUEST_ORIENTATION_LIST  } }
    function success(orientationList) { return { type: reportContentConstants.RECEIVE_ORIENTATION_LIST, orientationList } }
    function failure(error) { return { type: reportContentConstants.ORIENTATION_LIST_ERROR, error } }
}

function getSlotListHandler(){
    return dispatch => {
        dispatch(request());
        reportContentService.getSlotListHandler()
            .then(
                getSlotList => {
                    dispatch(success(getSlotList));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: reportContentConstants.REQUEST_SLOT_LIST  } }
    function success(getSlotList) { return { type: reportContentConstants.RECEIVE_SLOT_LIST, getSlotList } }
    function failure(error) { return { type: reportContentConstants.SLOT_LIST_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/reportContent/getReportContent.action.js